import FormInputText from '../Partials/FormInputText';
import GeneralForm from '../Forms/GeneralForm';
import FormSelect from '../Partials/FormSelect';

const SchemaPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            contents: [
                {
                    field: "changefreq",
                    partial: {
                        handler: FormSelect,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "changefreq");
                            },
                            required: true,
                            label: "دوره"
                        }
                    }
                },
                {
                    field: "priority",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "priority");
                            },
                            required: true,
                            label: "اولویت"
                        }
                    }
                }
            ]
        }
    }
};

export default SchemaPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/SchemaPageBuilder.js